import Image from "next/image";
import Link from "next/link";
import Head from "next/head";
// import interviewwebbanner from "../../assets/images/upsc/interview/Interview-web-banner.jpg";
// import Mobban from "../../assets/images/upsc/interview/Interview-Mob1-banner.jpg";
import NewiconA from "../../assets/images/header/pdf.png";
import modal from "../../assets/images/interview2022/modal.png";
import interview from "../../assets/images/interview2022/interview.png";
import books from "../../assets/images/interview2022/books.png";
import brochure from "../../assets/images/interview2022/brochure.png";
import pin from "../../assets/images/interview2022/pin.svg";
import medal from "../../assets/images/home/medal.webp";
import styles from "./upsc-interview.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(() => import("../../components/our-acheiver/achievers"));
//import Interview_2022_Free_Coaching_Form from "./upsc-interview-form";
//const pic10045 = "../../assets/images/Result/10045.webp";
//const pic10018 = "../../assets/images/Result/10018.webp";
//const pic10068 = "../../assets/images/Result/10068.webp";
//const pic10019 = "../../assets/images/Result/10019.webp";
//const pic10015 = "../../assets/images/Result/10015.webp";
const Interview_2022_Free_Coaching = () => {

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "UPSC Interview Registration | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/upsc-interview/",
    "Image": "https://www.shankariasacademy.com/_next/static/media/upsc.a9958312.jpg",
    "description": "Secure your spot! UPSC Interview Registration 2024 now open. Ace the final stage. Register today for a chance to join the ranks of excellence."
  }

  return (  
    <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Interview Registration | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Interview Registration | Shankar IAS Academy" />
            <meta name="description" content="Secure your spot! UPSC Interview Registration 2024 now open. Ace the final stage. Register today for a chance to join the ranks of excellence." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-interview/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Interview Registration | Shankar IAS Academy" />
            <meta property="og:description" content="Secure your spot! UPSC Interview Registration 2024 now open. Ace the final stage. Register today for a chance to join the ranks of excellence." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-interview/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

    <Navbar title="upsc" />

<div className="container">
  <div className="row">
    <div className="col pt-3 pt-md-4">
      <h1 className={`${styles.pagemaintitle}`}>UPSC Civil Service Interview 2024</h1>
    </div>
  </div>

  {/* <div className = "row d-none d-md-block">
      <div className="col">
          <Image
              src={interviewwebbanner}
              className="img-fluid w-100"
              alt="upsc-interview Banner"
              title="Interview 2022 - Free Coaching" 
            />
      </div>
  </div>

  <div className = "row d-block d-md-none">
      <div className="col">
            <Image
                src={Mobban}
                className="img-fluid w-100"
                alt="upsc-interview Banner"
                title="Interview 2022 - Free Coaching" 
              />
      </div>
  </div> */}
</div>

  {/* Desktop view */}
<div className="container pt-4">
    <div className="row d-none d-md-none d-lg-block ">
      <div className={`${styles.interviewbg}`}>
      <div className="d-flex justify-content-end py-3 py-md-5">
        <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox}`}>
          <p className="pt-3">UPSC Interview Registration 2024</p>
          <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
        </Link>
      </div>

        <p className={`${styles.bluetxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
      <div className= {`${styles.bluetxt1}`}>
        <Link href="/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target="_blank">
        <button className={`${styles.redbtn}`}>UPSC Civils Interview Schedule 2024  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
        </Link>
      </div>
      </div> 
    </div>
</div>


{/*Medium  Device*/}

  <div className="container pt-4">
    <div className="row d-none d-md-block d-lg-none">
    
      <div className="d-flex justify-content-center py-3 py-md-5">
        <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox}`}>
          <p className="pt-3">UPSC Interview Registration 2024</p>
          <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
        </Link>
      </div>
      <div className="justify-content-center">
      <p className={`${styles.bluetxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
      <div className= {`${styles.bluetxt1}`}>
        <Link href="/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target="_blank">
        <button className={`${styles.redbtn}`}>UPSC Civils Interview Schedule 2024  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
        </Link>
      </div>
     </div>
    </div>
  </div>

{/*Mobile View*/}

<div className="container">
    <div className="row  d-block d-md-none">
    <div className="d-flex justify-content-center py-3 py-md-5">
      <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox1}`}>
        <p className="pt-3">UPSC Interview Registration 2024</p>
        <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
      </Link>
       
    </div>
      <p className={`${styles.mobtxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
    <div className= {`${styles.mobtxt} justify-content-center`}>
      <Link href="/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target="_blank">
       <button className={`${styles.redbtn1}`}>UPSC Civils Interview Schedule 2024  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></button>
      </Link>
    </div>
    </div> 
  </div>

  {/*<div className="container">
  <div className="row">
    <div className="col pt-3 pt-md-4">
      <h1 className={`${styles.pagemaintitle}`}>Interview 2024 - Free Coaching</h1>
    </div>
  </div>

<div className="row">
<div className="row d-none d-md-block">
  <div className="col">
            <Image
              src={interviewwebbanner}
              className="img-fluid w-100"
              alt="upsc-interview Banner"
              title="Interview 2022 - Free Coaching"
             
            />
  </div>
  </div>

  <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={Mobban}
                className="img-fluid w-100"
              alt="upsc-interview Banner"
              title="Interview 2022 - Free Coaching"
              />
            </div>
  </div>
 <div className="d-flex justify-content-center py-3 py-md-5">
    <Link href="https://admissionsv1.shankariasacademy.com/civilisation-interview/" target="_blank" className={`${styles.btnbox}`}>
      <p className="pt-3">UPSC Interview Registration 2024</p>
      <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
    </Link>
  </div> 
</div>
</div>*/}

 {/*<div className="container">
  <div className="rows text-center pt-2 pb-3">
    <p className={`${styles.bluetxt}`}>SHANKAR IAS ACADEMY EDGE!</p>
    <Link href="/pdf/Interview-schedule-Final-1.pdf" target="_blank">
      <button className={`${styles.redbtn}`}>UPSC Civils Interview Schedule 2024</button>
    </Link>
  </div>
</div> */}

 {/*<Interview_2022_Free_Coaching_Form /> */}

<div className="container pt-5">
<div className="row">
  <div className="col">
  <h2 className={`${styles.sectiontitle}`}>Interview specific current affairs sessions</h2> 
  <p className={`${styles.acheiverrank} mb-0`}>Health, Nutrition, New Economic Survey, Polity and Governance, National Security, Women and Children, Social Justice and Empowerment, Foreign Policy</p>
  <p className={`${styles.acheiverrank}`}> (with respect to neighbours, super powers and others), Agriculture, Environment, State based issues, Govt. Policies and Schemes, Energy, Industry and others.</p>
  </div>
</div>
</div>  

<div className="container pt-3">
<div className="row">
    
      <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
        <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={modal}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>Individual personalised</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>one-on-one session.</p>
      </div>
      </div>
  
      <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
        <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={interview}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>Mock interviews by eminent</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>panelists, serving bureaucrats.</p>
        </div>
        </div>
        
          <div className="col-md-4 mb-3 mb-md-4 col-12 text-center">
            <div className={`${styles.facultyborder1} p-5 p-md-4 p-xl-5 h-100`}>
        <Image
              src={books}
              className="img-fluid"
              alt="interview session"
              title="Session"

            />
        <p className={`${styles.acheiverrank} text-center mb-0`}>Group based DAF profiling.</p>
        </div>
        </div>

</div>
</div>

<div className="container pt-2">
<div className="row">

  <div className="col-md-6 mb-3 mb-md-4">
    <div className={`${styles.aboutbox1} p-4 h-100`}>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-5">
        <Image
              src={brochure}
              className="img-fluid"
              alt="Brochure icon"
              title="Brochure"
            />
        </div>
          <div className="col-lg-9 col-md-8 col-7 ps-0">
            <p className={`${styles.sectionsubtitle} mb-0`}>Tamilnadu, Bengaluru,</p>
            <p className={`${styles.sectionsubtitle} mb-2`}>Thiruvananthapuram and Online</p>
            <a href="/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target={"_blank"} className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Download Brochure</a>
          </div>          
      </div>
    </div>
  </div>

  <div className="col-md-6 mb-3 mb-md-4">
    <div className={`${styles.aboutbox1} p-4 h-100`}>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-5">
        <Image
              src={brochure}
              className="img-fluid"
              alt="Brochure icon"
              title="Brochure"
            />
        </div>
          <div className="col-lg-9 col-md-8 col-7 ps-0 my-lg-3 my-0">
            <p className={`${styles.sectionsubtitle} mb-2`}>Delhi branch</p>
            <a href="/pdf/Interview-2024/Interview-Schedule-Final1-2024.pdf" target={"_blank"} className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Download Brochure</a>
          </div>          
      </div>
    </div>
  </div>

</div>
</div>

<div className="container pt-5">
<div className="row">
  <div className="col">
  <p className={`${styles.pagemaintitle}`}>Free UPSC IAS Mock Interview</p>
  <p className={`${styles.acheiverrank} mb-2`}>Shankar IAS Academy offers free IAS/UPSC mock interview preparation and interview guidance program for all civil service aspirants who cleared UPSC mains. 
  The mock interviews and personality test are under the guidance of retired, serving officers in Chennai, Bangalore, Delhi and Trivandrum centres.</p>
  <p className={`${styles.acheiverrank} mb-2`}>Feedback will be given by the eminent panelist indicating the strength and weakness of the students who face the mock session.</p>
  <p className={`${styles.acheiverrank}`}>The UPSC IAS mock interview is an integral part of the IAS preparation process as it helps the students to understand the expectations of 
  the interview board and how to present themselves in the best possible way. The mock interview is conducted by experienced and well-trained interviewers who have a deep understanding of the UPSC interview process. They are well-versed with the current affairs and the issues that are relevant to the UPSC exam and can provide the students with valuable feedback on their performance.</p>
  <p className={`${styles.acheiverrank} mb-2`}>The UPSC mock interview is conducted in a simulated environment that is similar to the real UPSC interview. The students are given a topic to speak on and are asked questions related to it. They are also given feedback on their body language, confidence level, and communication skills. The interviewers also provide the students with tips and tricks on how to improve their performance in the real interview.</p>
  <p className={`${styles.acheiverrank} mb-2`}>The UPSC mock interview at Shankar IAS Academy is not just limited to the students who are enrolled in the academy. The academy also provides the mock interview service to other students who are preparing for the UPSC exam. This is a great opportunity for the students who are not enrolled in the academy to get a feel of the interview process and to receive valuable feedback on their performance. </p>
  <p className={`${styles.pagemaintitle} pt-3`}>UPSC/IAS Mock Interview Guidance Programme 2024</p>
  <p className={`${styles.acheiverrank} mb-2`}>The academy also provides the UPSC mock interview guidance programme to other students who are preparing for the UPSC exam, which is a great opportunity for them to get a feel of the interview process and to receive valuable feedback on their performance.</p>
  </div>
</div>
</div>

<div className="container pt-3">
<div className="row">
  <div className="col">
  <p className={`${styles.pagemaintitle}`}>Why You Should join IAS/UPSC Mock Interview Programme</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> Pre Mock (SWOT Analysis) sessions by SIA Interview Experts Team</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> SWOT analysis is specifically suited for aspirants with prior interview exposure looking for score upgrade</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> Personalised DAF profiling sessions.</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> Interview centric expert lectures by domain experts</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> Interview mentorship programme - Candidates are assigned to personal mentors(Young Bureaucrats)</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> One-on-one sessions.</p>
  <p className={`${styles.acheiverrank} mb-2`}> <span className={`${styles.dot} pe-2`}>* </span> Mock Interview by serving and retired bureaucrats.</p>
  <p className={`${styles.acheiverrank} pt-3`}>In conclusion, the UPSC mock interview at Shankar IAS Academy is an essential part of the IAS preparation process. It helps the students to understand the expectations of the interview board and how to present themselves in the best possible way. The mock interview is conducted by experienced and well-trained interviewers who provide valuable feedback to the students on their performance.</p>
  </div>
</div>
</div>

<div className="container pt-3">

<p className={`${styles.pagemaintitle} mb-3`}>Our Centers</p>

<div className="row">     
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Chennai location"
              title="Chennai location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Chennai</p>          
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Delhi location"
              title="Delhi location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Delhi</p> 
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Bengaluru location"
              title="Bengaluru location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Bengaluru</p> 
  </div>
  <div className="col-lg-3">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Thiruvananthapuram location"
              title="Thiruvananthapuram location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Thiruvananthapuram</p> 
  </div>
  <div className="col-lg-2">
  <p className={`${styles.acheiverrank}`}>
            <Image
              src={pin}
              className="img-fluid"
              alt="Hyderabad location"
              title="Hyderabad location"

            />&nbsp;&nbsp;&nbsp;&nbsp;Hyderabad</p> 
  </div>

</div>
</div>

<div className="container-fluid pt-md-5 pt-4 px-0">
<div className="row mx-auto"> 
  <div className={`${styles.bground} mb-5`}>

<div className="container">
<div className="row">
  <div className="col text-center">
            <Image
              src={medal}
              className="img-fluid"
              alt="medal icon"
              title="Medal"

            />
  </div>
</div>
</div>

<div className="container pt-4">
<div className="row">
  <div className="col">
  <h2 className={`${styles.sectiontitle} text-center mb-0`}>Our Achievements</h2>
  </div>
</div>
</div>   

    <div className="container">
      <div className="row pt-md-2 mb-md-5 justify-content-center">

                          <div className="col-lg-3 col-md-4 col-12 pt-4 pt-md-5">
                              <p className={`${styles.ourachievementcontent}`}>8</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>Candidates scored</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>200+ Marks</p>
                          </div>

                          <div className="col-lg-3 col-md-4 col-12 pt-4 pt-md-5">
                              <p className={`${styles.ourachievementcontent}`}>36</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>Candidates scored</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>190+ Marks</p>
                          </div>
                          
                          <div className="col-lg-3 col-md-4 col-12 pt-4 pt-md-5">
                              <p className={`${styles.ourachievementcontent}`}>34</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>Candidates scored</p>
                              <p className={`${styles.acheiverrank} text-center mb-0`}>180+ Marks</p>
                          </div>
                  
      </div>      
    </div>

    <div className="container pt-4">
    <div className="row">
     <div className="col">
     <h2 className={`${styles.sectiontitle} text-center mb-0`}>Our Achievers</h2>
     <h3 className={`${styles.sectionsubtitle} text-center`} style={{whiteSpace: "nowrap"}}>Rank Holders from our academy</h3>
     </div>
    </div>
    </div>   

</div>
</div>
</div>

<div className="container">
<div className="row">
  <div className="col">
  <Acheiver />
  {/*  <div className={`${styles.scrollparent}`} id={styles.acheiverscrollparent}>

      <div className={`${styles.scrolldiv} pe-3 pe-lg-1`}>
            <Image
              src={pic10045}
              className="img-fluid"
              title="S Sivanandham"
              alt="S Sivanandham"
              width={200}
              height={200}

            />
        <p className={`${styles.acheivername} my-2 text-center`}>S Sivanandham</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>AIR 87</p>
        <p className={`${styles.acheiverrank} text-center`}>205 Marks</p>
      </div>

      <div className={`${styles.scrolldiv} pe-3 pe-lg-1`}>
            <Image
              src={pic10018}
              className="img-fluid"
              title="Anshu Priya"
              alt="Anshu Priya"
              width={200}
              height={200}

            />        
        <p className={`${styles.acheivername} my-2 text-center`}>Anshu Priya</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>AIR 16</p>
        <p className={`${styles.acheiverrank} text-center`}>204 Marks</p>
      </div>

      <div className={`${styles.scrolldiv} pe-3 pe-lg-1`}>
            <Image
              src={pic10068}
              className="img-fluid"
              title="Simran Bhardwaj"
              alt="Simran Bhardwaj"
              width={200}
              height={200}

            />
        <p className={`${styles.acheivername} my-2 text-center`}>Simran Bhardwaj</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>AIR 172</p>
        <p className={`${styles.acheiverrank} text-center`}>201 Marks</p>
      </div>

      <div className={`${styles.scrolldiv} pe-3 pe-lg-1`}>
            <Image
              src={pic10019}
              className="img-fluid"
              title="Dilip K Kainikkara"
              alt="Dilip K Kainikkara"
              width={200}
              height={200}

            />
        <p className={`${styles.acheivername} my-2 text-center`}>Dilip K Kainikkara</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>AIR 21</p>
        <p className={`${styles.acheiverrank} text-center`}>201 Marks</p>
      </div>

      <div className={`${styles.scrolldiv}`}>
            <Image
              src={pic10015}
              className="img-fluid"
              title="Preetam Kumar"
              alt="Preetam Kumar"
              width={200}
              height={200}

            />
        <p className={`${styles.acheivername} my-2 text-center`}>Preetam Kumar</p>
        <p className={`${styles.acheiverrank} text-center mb-0`}>AIR 9</p>
        <p className={`${styles.acheiverrank} text-center`}>201 Marks</p>
      </div>

    </div>   */}

  </div>
</div>
</div>

<Interest />

    <Footer />
    </>
  )
}

export default Interview_2022_Free_Coaching
